var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { class: _vm.navclass }, [
    _c(
      "ul",
      { staticClass: "nav nav--subnavigation" },
      _vm._l(_vm.visibleItems, function(item, index) {
        return _c(
          "li",
          { key: index, staticClass: "nav--subnavigation__item" },
          [
            _c(
              "a",
              {
                staticClass: "nav--subnavigation__link ga-category-link",
                attrs: { href: item.link }
              },
              [_vm._v(_vm._s(item.title))]
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.items.length > 6 && !_vm.showAllItems
      ? _c(
          "button",
          {
            staticClass: "subnavigation-button show-more-button",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.toggle()
              }
            }
          },
          [_vm._v("\n    " + _vm._s(_vm.$modeoL10n.show_all) + "\n  ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12a4720c", { render: render, staticRenderFns: staticRenderFns })
  }
}